import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import Modal from 'react-modal';

import { Amplify } from 'aws-amplify';
// import {awsAuthAdmin} from './aws-config.js';

// react-router-dom
import { BrowserRouter } from 'react-router-dom';

// easy-peasy
import { StoreProvider } from 'easy-peasy';

// services (store)
import services from './services';

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_REGION,
    userPoolId: process.env.REACT_APP_POOL_ID_ADMIN,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID_ADMIN,
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    mandatorySignIn: true,
  },
  Storage: {
    AWSS3: {
      bucket: process.env.REACT_APP_BUCKET,
      region: process.env.REACT_APP_REGION,
    },
  },
});

// Configuration pour React Modal
Modal.setAppElement('#root');

// Initialisation de l'application React
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <StoreProvider store={services}>
      <App />
    </StoreProvider>
  </BrowserRouter>
);

// Enregistrement du Service Worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered:', registration);
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
}
